import { faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Button,
  JoonUIColor,
  Modal,
  ModalHeader,
  Typography,
} from "@joonapp/web-shared"
import { useState } from "react"

import UserBadge from "../../../components/badges/userBadge/UserBadge"
import { QUERY_KEYS } from "../../../constants"
import { InvitationGroup } from "../../../types"
import { createJoonAPIClient } from "../../../util/joon-api"
import { queryClient } from "../../../util/queryClient"

export interface TherapistInvite {
  id: number
  therapist: {
    email: string
  }
  children: {
    id: number
    name: string
  }[]
}

const TherapistInviteItem = ({
  invitationGroup,
}: {
  invitationGroup: InvitationGroup
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const inviteeEmail = invitationGroup[0].invitee_email
  const subjectData = invitationGroup.flatMap(
    (invitation) => invitation.subject_user
  )

  const handleDeleteInvitation = async () => {
    const API = createJoonAPIClient()
    try {
      setIsDeleting(true)
      const promises = invitationGroup.map((invitation) =>
        API.delete(`api/invitations/${invitation.id}/`)
      )
      await Promise.all(promises)
      await queryClient.invalidateQueries([QUERY_KEYS.THERAPIST_INVITES])
      setIsDeleteModalOpen(false)
    } catch (error) {
      console.error(error)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div className="flex flex-col gap-2 bg-white rounded-md p-4 border border-borderPrimary w-[99%]">
      <div className="bg-blue-200 rounded-md w-fit flex items-center justify-center px-1 py-0.5">
        <Typography variant="bodyXSmall">Pending</Typography>
      </div>
      <div className="flex flex-row justify-between gap-2">
        <Typography variant="bodySmallBold">{inviteeEmail}</Typography>
        <button onClick={() => setIsDeleteModalOpen(true)}>
          <FontAwesomeIcon icon={faTrashCan} color={JoonUIColor.icon.neutral} />
        </button>
      </div>
      <div className="flex gap-1 flex-wrap">
        {subjectData.map((subject) => (
          <UserBadge userId={subject.id} key={subject.id} />
        ))}
      </div>

      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        style={{ width: "min(300px, 95vw)" }}
      >
        <ModalHeader
          onClose={() => setIsDeleteModalOpen(false)}
          showBorderBottom
          title="Are you sure?"
        />
        <div className="flex flex-col p-6 pt-4 gap-6">
          <Typography variant="body">You cannot undo this action.</Typography>
          <Button
            buttonType="redPrimary"
            text="Remove invitation"
            onClick={handleDeleteInvitation}
            fullWidth
            isLoading={isDeleting}
          />
        </div>
      </Modal>
    </div>
  )
}
export default TherapistInviteItem
